const SAVE = 'SAVE_RETAILERS';

export function retailersReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}
